import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  text-align: ${props => props.align || 'center'};
  color: var(--text-primary);
`;

const Stars = styled.div`
  color: ${props => props.color || '#fbbf24'};
  font-size: ${props => props.size || '24px'};
  letter-spacing: 2px;
  margin-bottom: 5px;
`;

const Label = styled.div`
  font-size: 14px;
  color: var(--text-muted);
  font-weight: bold;
`;

const StarRatingWidget = ({ node }) => {
  const rating = parseFloat(node.content?.rating || 4.5);
  const max = 5;
  let starsHtml = '';
  
  for(let i=1; i<=max; i++) {
    if (rating >= i) starsHtml += '★';
    else if (rating >= i - 0.5) starsHtml += '⯪'; // Half star mock (usually would use SVG or font-awesome)
    else starsHtml += '☆';
  }

  // Fallback for half star unicode if missing
  starsHtml = starsHtml.replace('⯪', '★'); // Just mock as full for simple font compatibility

  return (
    <Wrapper align={node.style?.desktop?.align}>
      <Stars color={node.style?.desktop?.color} size={node.style?.desktop?.size}>{starsHtml}</Stars>
      <Label>{rating} von 5 Sternen ({node.content?.reviews || 128} Bewertungen)</Label>
    </Wrapper>
  );
};

registry.register('star_rating', {
  label: 'Star Rating',
  icon: '⭐',
  category: 'advanced',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', color: '#fbbf24', size: '24px' } },
  render: StarRatingWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Bewertung', fields: [{name:'content.rating', label:'Sterne (z.B. 4.5)', type:'text'}, {name:'content.reviews', label:'Anzahl Bewertungen', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Design', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Links', value:'left'},{label:'Center', value:'center'},{label:'Rechts', value:'right'}]}, {name:'style.desktop.color', label:'Stern-Farbe', type:'text'}, {name:'style.desktop.size', label:'Größe', type:'text'}] }] }
  ]
});
